import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { SentHistoryRecord } from './sent-history.model';

@Component({
  selector: 'app-sent-history',
  templateUrl: './sent-history.component.html',
  styleUrls: ['./sent-history.component.scss']
})
export class SentHistoryComponent implements OnInit {
  sentTimes: number;
  lang: string;

  totalTimes: number;
  policyNo: string;
  sendRecords: SentHistoryRecord[];

  constructor(public sentHistoryModalRef: BsModalRef, private translationService: TranslateService) {}

  ngOnInit(): void {
    this.setSentTimes();
    this.translationService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.lang = event.lang;
    });
  }

  private setSentTimes(): void {
    const maxTimes = 3;
    this.sentTimes = this.totalTimes < maxTimes ? this.totalTimes : maxTimes;
  }

  closeModal(): void {
    this.sentHistoryModalRef.hide();
  }
}
